import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
//Limitless imports
import { PortalButton } from "@limitless/portal";
const useStyles = makeStyles(() => ({
  buttonContainer: {
    marginTop: 24,
    display: "flex",
    justifyContent: "space-between",
    marginRight: 42
  },
  button: {
    width: 145
  }
}));
const BrandLearningCta = ({
  content,
  tabContent,
  selectedTabIndex,
  brandLearningCtaClick,
  brandLearningCtaBackClick,
  brandLearningCtaNextClick
}) => {
  var _tabContent$tabSectio, _tabContent$tabSectio2, _tabContent$tabSectio3;
  const classes = useStyles();
  const {
    buttonLabelBack = "Back",
    buttonLabel,
    buttonLabelNext = "Next"
  } = content;
  return /*#__PURE__*/React.createElement(Grid, {
    className: classes.buttonContainer
  }, ((_tabContent$tabSectio = tabContent.tabSections) === null || _tabContent$tabSectio === void 0 ? void 0 : _tabContent$tabSectio.length) <= 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PortalButton, {
    className: classes.button,
    disabled: true,
    onClick: () => brandLearningCtaBackClick && brandLearningCtaBackClick()
  }, buttonLabelBack), /*#__PURE__*/React.createElement(PortalButton, {
    className: classes.button,
    onClick: () => brandLearningCtaClick && brandLearningCtaClick()
  }, buttonLabel)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PortalButton, {
    className: classes.button,
    disabled: selectedTabIndex <= 0,
    onClick: () => brandLearningCtaBackClick && brandLearningCtaBackClick()
  }, buttonLabelBack), selectedTabIndex !== ((_tabContent$tabSectio2 = tabContent.tabSections) === null || _tabContent$tabSectio2 === void 0 ? void 0 : _tabContent$tabSectio2.length) - 1 && /*#__PURE__*/React.createElement(PortalButton, {
    className: classes.button,
    onClick: () => brandLearningCtaNextClick && brandLearningCtaNextClick()
  }, buttonLabelNext), selectedTabIndex === ((_tabContent$tabSectio3 = tabContent.tabSections) === null || _tabContent$tabSectio3 === void 0 ? void 0 : _tabContent$tabSectio3.length) - 1 && /*#__PURE__*/React.createElement(PortalButton, {
    className: classes.button,
    onClick: () => brandLearningCtaClick && brandLearningCtaClick()
  }, buttonLabel)));
};
BrandLearningCta.propTypes = {
  content: PropTypes.object.isRequired,
  tabContent: PropTypes.object.isRequired,
  brandLearningCtaClick: PropTypes.func,
  selectedTabIndex: PropTypes.number,
  brandLearningCtaBackClick: PropTypes.func,
  brandLearningCtaNextClick: PropTypes.func
};
export default BrandLearningCta;